export const NETWORK_CAMPAIGNS_PAGE = "campaignsPage"
export const CAMPAIGNS_COUNT_PER_PAGE = 30